export const ENVIRONMENTS = {
  LOCAL: 'LOCAL',
  DEVELOPMENT: 'dev',
  STAGE: 'stg',
  PRODUCTION: 'prd',
};
